module.exports = __webpack_public_path__ + "static/img/智慧网银云3.b3a3ef3e.png";